export type BorderColor = "gray" | "gray-hard" | "primary" | "error" | "transparent";
export type BgColor = "default" | "base" | "alt1" | "alt2" | "error";
export type FgColor = "default" | "subtle" | "error" | "info" | "warning" | "success" | "accent3";

export function borderClassName(
  twBorder: string,
  color: BorderColor | boolean | undefined,
): string | undefined {
  switch (color) {
    case true:
    case "gray":
      return `${twBorder} border-gray`;
    case "gray-hard":
      return `${twBorder} border-gray-hard`;
    case "primary":
      return `${twBorder} border-primary`;
    case "error":
      return `${twBorder} border-error`;
    case "transparent":
      return `${twBorder} border-transparent`;
  }
}

export function bgColorClassName(color: BgColor | boolean | undefined) {
  switch (color) {
    case true:
    case "default":
      return "bg-default";
    case "base":
      return "bg-base";
    case "alt1":
      return "bg-alt1";
    case "alt2":
      return "bg-alt2";
    case "error":
      return "bg-error";
  }
}

export function fgColorClassName(color: FgColor | boolean | undefined) {
  switch (color) {
    case true:
    case "default":
      return "color-default";
    case "subtle":
      return "subtle";
    case "error":
      return "color-error";
    case "info":
      return "color-info";
    case "warning":
      return "color-warning";
    case "success":
      return "color-success";
    case "accent3":
      return "color-accent3";
  }
}
